import {all, call, debounce, put, take, takeLatest} from 'redux-saga/effects';
import {APP_BOOTSTRAP, APP_LOAD_INIT_VALUES, APP_LOAD_REQUIRES} from './constants';
import app from '@src/helpers/app';
import {setBooted, setBooting, setFatalError, setLoaded, setLoading, setWorkSchedule} from './actions';
import getRequiredActionsBeforeAppLoaded from './requiredActionsBeforeAppLoaded';
import {IApiRoute, IClientRoute} from '@src/@interfaces/services/Database';
import {setApiRoutes, setClientRoutes} from '../routes/actions';
import {StringArray} from '@src/@interfaces/types';
import {IMessagesBag} from '@src/@interfaces/services/Localisation/IMessagesBag';
import {setLocalisations} from '../locale/actions';
import {IFormConfig} from '@src/@interfaces/components/Form/IFormConfig';
import {setFormsConfigs} from '../forms/actions';
import {setNavigationConfig} from '../navigation/actions';
import {IReduxAppState, IReduxNavigationState} from '@src/@interfaces';
import config from '@src/helpers/config';

export function* bootSaga() {
    yield takeLatest(APP_BOOTSTRAP, function* () {
        yield put(setBooting());
        yield call(() => app().boot());
        yield put(setBooted());
    });
}

export function* loadRequiresSaga() {
    yield takeLatest(APP_LOAD_REQUIRES, function* () {
        yield put(setLoading());
        yield call(() => app().loadRequires());

        const requiredActionsBeforeLoaded = getRequiredActionsBeforeAppLoaded();
        for (let i = 0; i < requiredActionsBeforeLoaded.length; i++) {
            yield take(requiredActionsBeforeLoaded);
        }

        yield put(setLoaded());
    });
}

export function* loadInitValues() {
    yield debounce(30, APP_LOAD_INIT_VALUES, function* () {
        try {
            const response: Record<string, any> = yield call(() => {
                return app('http').request(
                    config('client.init-values-url')
                );
            });

            const routes: IApiRoute[] = response['routes'];
            const clientRoutes: IClientRoute[] = response['client-routes'];
            const localisations: IMessagesBag = response['localisations'];
            const configs: StringArray<IFormConfig> = response['forms-configs'];
            const navigation: IReduxNavigationState = response['navigation'];
            const schedule: IReduxAppState['workSchedule'] = response['workSchedule'];

            yield put(setApiRoutes(routes));
            yield put(setClientRoutes(clientRoutes));
            yield put(setLocalisations(localisations));
            yield put(setFormsConfigs(configs));
            yield put(setNavigationConfig(navigation));
            yield put(setWorkSchedule(schedule));
        } catch (error) {
            yield put(setFatalError(error as any));
        }
    });
}

export function* appSagasWatchers() {
    yield all([
        bootSaga(),
        loadRequiresSaga(),
        loadInitValues(),
    ]);
}
